import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { sendLink } from '../../../store/auth/actions'
import Typography from '@material-ui/core/Typography';
import Alert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    textCapitalise: {
        textTransform: 'capitalize'
    }
}))

export default function ForgotPassword({ onCancel }) {

    const classes = useStyles();

    const { register, handleSubmit, reset, formState: { errors }, watch } = useForm();
    const dispatch = useDispatch();
    const hostname = window.location.hostname;
    const port = window.location.port;
    const [mailResponse, setMailResponse] = useState(false);
    const [disableSent, setDisableSent] = useState(false);



    const sendResetLink = async ({ email }) => {
        setMailResponse(false)
        setDisableSent(true)
        const resetPayload = { email, hostname, port }

        const response = await dispatch(sendLink(resetPayload));
        setMailResponse(response)
        setDisableSent(false)


    }

    return (
        <Grid id={"forgot_password_form"} container direction={"row"} spacing={3} style={{ marginTop: 30 }}>

            <Grid item xs={12}>
                <Typography>Enter the registered email</Typography>
            </Grid>


            {mailResponse !== false && 
            <Grid id={"send_link_feedback"} item xs={12}>
                {mailResponse.status && <Alert id={"success_message"} severity="success">{mailResponse.message}</Alert>}
                {!mailResponse.status && <Alert id={"error_message"} severity="error">{mailResponse.message}</Alert>}
            </Grid>}


            <Grid item xs={12}>
                {/* <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    id="userEmail"
                    label="Email"
                    name="userEmail"
                    autoComplete="userEmail"
                    autoFocus
                    inputRef={register({ required: true })}
                /> */}
                <TextField
                    name="email"
                    autoFocus
                    fullWidth
                    type={"text"}
                    required={true}
                    label={"Email"}
                    placeholder={""}
                    variant="outlined"
                    //inputRef={register({ ...basic, validate: duplicateDigitalTwinName })}
                    inputRef={register({})}
                //error={errors?.name ? true : false}
                //helperText={errors?.name ? messages[errors?.name?.type] : ''}
                />
            </Grid>
            {/* {mailResponse != '' && <Grid item xs={12}>
                <Typography>{mailResponse}</Typography>
            </Grid>} */}

            <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end", marginBottom: 20 }}>
                <Button onClick={onCancel} variant="contained" style={{ marginLeft: 10 }} className={classes.textCapitalise} >
                    Go To Login
                </Button>
                <Button onClick={handleSubmit(sendResetLink)} disabled={disableSent} color="primary" variant="contained" style={{ marginLeft: 10 }} className={classes.textCapitalise}>
                    Send Link
                </Button>
            </Grid>


        </Grid>
    )
}